import { render } from "./CreateNewCustomer.vue?vue&type=template&id=b46a5d64&ts=true"
import script from "./CreateNewCustomer.vue?vue&type=script&lang=ts"
export * from "./CreateNewCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__